import {
  Box,
  useTheme,
  InputLabel,
  MenuItem,
  Grid,
  FormControl,
  FormControlLabel,
  TextField,
  Tooltip,
  FormHelperText,
  Select,
  Snackbar,
  RadioGroup,
  Radio,
  Card,
  CardContent,
  CardHeader,
  Button,
} from "@mui/material";
import { tokens } from "../../theme";
import Header from "../Componentes/Header";

import { useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";

import { GuardarEncuesta } from "../../Api/ApiGuardar";

export default function Dashboard() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const styles = {
    formControlLabel: {
      color: "#151516",
      span: {
        color: "#151516",
      },
      borderRadius: "10%",
      justifyContent: "center",
    },
  };
  const InicialValoresDatosPersona = {
    Pregunta3: "",
    Pregunta4: "",
    Seleccion: "",
    Seleccion2: "",
    Opcion: "",
    Opcion2: "",
    Opcion3: "",
    Comentarios: "", // Agregado el campo para el TextArea
  };
  const checkoutSchemaDatosPersona = yup.object().shape({
    Pregunta3: yup.string().required("Esta pregunta es requerida"),
    Pregunta4: yup.string().required("Esta pregunta es requerida"),
    Opcion: yup.string().required("Selecciona una opción"),
    Opcion2: yup.string().required("Selecciona una opción"),
    Opcion3: yup.string().required("Selecciona una opción"),
    Seleccion: yup.string().required("Selecciona una opción"),
    Seleccion2: yup.string().required("Selecciona una opción"),
    Comentarios: yup.string(), // Validación opcional
  });

  //NOTIFICACIONES-------------------------------------------------------------------------------------------------------------------------
  const [Notificaciones, setNotificaciones] = useState([]);
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  // SUBMIT ---------------------------------------------------
  async function HandlerSubmitEncuesta(values, onSubmitProps) {
    const GuardarDatosEncuesta = await GuardarEncuesta(values);
    setNotificaciones(GuardarDatosEncuesta[0].message);
    if (GuardarDatosEncuesta[0].message === " Registro Creado ") {
      onSubmitProps.resetForm();
    }
    if (GuardarDatosEncuesta[0].message === " Existe correo registrado ") {
      onSubmitProps.resetForm();
    }
    handleClick();
  }

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="center" alignItems="center" mb={4}>
        <Header
          title="ENCUESTA DE SATISFACCIÓN"
          subtitle="Página web CONATEL"
        />
      </Box>
      <Formik
        onSubmit={HandlerSubmitEncuesta}
        initialValues={InicialValoresDatosPersona}
        validationSchema={checkoutSchemaDatosPersona}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          resetForm,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={4}>
                <Card sx={{ background: colors.primary[400], p: 2 }}>
                  <CardHeader
                    title="¿Encontraste la información que buscabas?"
                    titleTypographyProps={{ variant: "h5", fontWeight: "bold" }}
                  />
                  <CardContent>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="Opcion"
                        value={values.Opcion}
                        onChange={handleChange}
                      >
                        <Box sx={styles.formControlLabel}>
                          <FormControlLabel
                            value="1"
                            control={<Radio />}
                            label="SI"
                          />
                        </Box>
                        <Box sx={styles.formControlLabel}>
                          <FormControlLabel
                            value="2"
                            control={<Radio />}
                            label="NO"
                          />
                        </Box>
                      </RadioGroup>
                      {touched.Opcion && errors.Opcion && (
                        <FormHelperText error>{errors.Opcion}</FormHelperText>
                      )}
                    </FormControl>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card sx={{ background: colors.primary[400], p: 2 }}>
                  <CardHeader
                    title="¿Es clara la información?"
                    titleTypographyProps={{ variant: "h5", fontWeight: "bold" }}
                  />

                  <CardContent>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="Opcion2"
                        value={values.Opcion2}
                        onChange={handleChange}
                      >
                        <Box sx={styles.formControlLabel}>
                          <FormControlLabel
                            value="1"
                            control={<Radio />}
                            label="SI"
                          />
                        </Box>
                        <Box sx={styles.formControlLabel}>
                          <FormControlLabel
                            value="2"
                            control={<Radio />}
                            label="NO"
                          />
                        </Box>
                      </RadioGroup>
                      {touched.Opcion2 && errors.Opcion2 && (
                        <FormHelperText error>{errors.Opcion2}</FormHelperText>
                      )}
                    </FormControl>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card sx={{ background: colors.primary[400], p: 2 }}>
                  <CardHeader
                    title="¿Le resulto fácil la información que buscaba?"
                    titleTypographyProps={{ variant: "h5", fontWeight: "bold" }}
                  />
                  <CardContent>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="Opcion3"
                        value={values.Opcion3}
                        onChange={handleChange}
                      >
                        <Box sx={styles.formControlLabel}>
                          <FormControlLabel
                            value="1"
                            control={<Radio />}
                            label="SI"
                          />
                        </Box>
                        <Box sx={styles.formControlLabel}>
                          <FormControlLabel
                            value="2"
                            control={<Radio />}
                            label="NO"
                          />
                        </Box>
                      </RadioGroup>
                      {touched.Opcion3 && errors.Opcion3 && (
                        <FormHelperText error>{errors.Opcion3}</FormHelperText>
                      )}
                    </FormControl>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Card sx={{ background: colors.primary[400], p: 3 }}>
                  <CardHeader
                    title="Preguntas"
                    titleTypographyProps={{
                      variant: "h5",
                      fontWeight: "bold",
                      align: "left",
                    }}
                  />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <FormControl
                          color="secondary"
                          fullWidth
                          variant="filled"
                          error={!!touched.Seleccion && !!errors.Seleccion}
                        >
                          <InputLabel>
                            ¿Cómo calificaría el diseño y la presentación de
                            nuestro sitio web?
                          </InputLabel>
                          <Select
                            name="Seleccion"
                            value={values.Seleccion}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <MenuItem value="1">Excelente</MenuItem>
                            <MenuItem value="2">Buena</MenuItem>
                            <MenuItem value="3">Regular</MenuItem>
                            <MenuItem value="4">Mala</MenuItem>
                          </Select>
                          {touched.Seleccion && errors.Seleccion && (
                            <FormHelperText>{errors.Seleccion}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl
                          color="secondary"
                          fullWidth
                          variant="filled"
                          error={!!touched.Seleccion2 && !!errors.Seleccion2}
                        >
                          <InputLabel>
                            ¿Qué tan satisfecho está con la información y los
                            servicios proporcionados en nuestro sitio web?
                          </InputLabel>
                          <Select
                            name="Seleccion2"
                            value={values.Seleccion2}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <MenuItem value="1">Muy satisfecho</MenuItem>
                            <MenuItem value="2">Satisfecho</MenuItem>
                            <MenuItem value="3">Poco satisfecho</MenuItem>
                            <MenuItem value="4">Insatisfecho</MenuItem>
                          </Select>
                          {touched.Seleccion2 && errors.Seleccion2 && (
                            <FormHelperText>{errors.Seleccion2}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          color="secondary"
                          fullWidth
                          variant="filled"
                          label="¿Qué aspecto de nuestro sitio web le resultó más útil?"
                          name="Pregunta3"
                          value={values.Pregunta3}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.Pregunta3 && !!errors.Pregunta3}
                          helperText={touched.Pregunta3 && errors.Pregunta3}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          color="secondary"
                          fullWidth
                          variant="filled"
                          label="¿Tiene algún comentario adicional o sugerencia para mejorar nuestro sitio web?"
                          name="Pregunta4"
                          value={values.Pregunta4}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.Pregunta4 && !!errors.Pregunta4}
                          helperText={touched.Pregunta4 && errors.Pregunta4}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} display="flex" justifyContent="center">
                <Tooltip title="Enviar encuesta">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    startIcon={<SaveAsOutlinedIcon />}
                    sx={{
                      textTransform: "none",
                      fontWeight: "bold",
                      padding: "10px 20px",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Enviar encuesta
                  </Button>
                </Tooltip>
              </Grid>
              <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message={Notificaciones}
              ></Snackbar>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
